/**
 * TODO: We don't need this singleton.
 *
 * Chevron lib itself prevents multiple instances from being created.
 *
 * We also do not need to define the Chevron environment explicitly here, if we follow the documentation
 * and environment variables that Chevron will pick up automatically.
 */

import Chevron from '@lp/chevron';

// Map Vite modes to the expected Chevron environment values
const getChevronEnvironment = (): 'PRODUCTION' | 'DEVELOPMENT' | 'DOCKER' => {
  // Override with explicitly set environment variable
  if (import.meta.env.VITE_CHEVRON_ENV) {
    return import.meta.env.VITE_CHEVRON_ENV as 'PRODUCTION' | 'DEVELOPMENT' | 'DOCKER';
  }

  switch (import.meta.env.MODE) {
    case 'production':
      return 'PRODUCTION';
    case 'staging':
      return 'DEVELOPMENT';
    case 'development':
      return 'DOCKER';
    default:
      return 'PRODUCTION';
  }
};

const chevron = Chevron.getInstance({
  ENV: getChevronEnvironment(),
});

export default chevron;
